export default __webpack_public_path__ + "static/media/cover2.baa04854.png";